<template>
    <span>
        <component
            :is="part.match ? 'mark' : 'span'"
            v-for="(part, index) in parts"
            :key="`${index}-${part.text}`"
            :class="{'workforce-search-highlight': part.match}"
        >
            {{ part.text }}
        </component>
    </span>
</template>

<script>
function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default {
    name: 'WorkforceSearchHighlight',
    props: {
        text: {
            type: [String, Number],
            default: ''
        },
        query: {
            type: String,
            default: ''
        }
    },
    computed: {
        tokens() {
            const seen = {};
            return String(this.query || '')
                .trim()
                .split(/\s+/)
                .map(token => token.toLocaleLowerCase('ru-RU'))
                .filter(token => {
                    if (!token || seen[token]) {
                        return false;
                    }
                    seen[token] = true;
                    return true;
                })
                .sort((left, right) => right.length - left.length);
        },
        parts() {
            const value = String(
                this.text === null || this.text === undefined ? '' : this.text
            );
            if (!value || !this.tokens.length) {
                return [{text: value, match: false}];
            }
            const tokenSet = new Set(this.tokens);
            const pattern = new RegExp(
                `(${this.tokens.map(escapeRegExp).join('|')})`,
                'giu'
            );
            return value.split(pattern)
                .filter(part => part !== '')
                .map(part => ({
                    text: part,
                    match: tokenSet.has(part.toLocaleLowerCase('ru-RU'))
                }));
        }
    }
};
</script>

<style scoped>
.workforce-search-highlight {
    padding: 0 0.08em;
    border-radius: 2px;
    background: #ffd54f;
    color: inherit;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
}
</style>
